import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  langTmp: true,
  lang: 'zh',
  poster: ''
}
const mutations = {
  changeLang (state, data) {
    if (state.langTmp) {
      state.lang = 'tw'
      state.langTmp = !state.langTmp
      // console.log(`简体` + data)
    } else {
      state.lang = 'zh'
      state.langTmp = !state.langTmp
      // console.log(`繁体` + data)
    }
  }
}
export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js